import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
//
import DashboardNavbarDlc from './DashboardNavbarDlc';
import DashboardSidebar from './DashboardSidebar';
import DashboardTimer from './DashboardTimer';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 60;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    paddingTop: APP_BAR_DESKTOP ,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayoutDlc() {

  return (
    <RootStyle>
      <DashboardTimer minutes={1} />
      <DashboardNavbarDlc />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
